import React, { useEffect, useState } from "react";
import { Alert, Button, Col, Form, Input, Row, Switch } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../../store/store";
import { upateUserPersonalInformation } from "../../../../../api/user/user";
import { openNotificationWithIcon } from "../../../../../utils/helper";
import { updateUser } from "../../../../../store/userSlice/userSlice";

const Teacheraccountinfo = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const [error, setError] = useState<any>(null);
  const [showVisibility, setShowVisibility] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({
    firstName: "",
    lastName: "",
    email: "",
  });

  const state = useSelector((state: RootState) => ({
    user: state.user.user,
  }));

  const { user } = state;

  const onFinish = async (values: any) => {
    const { lastName, firstName } = values;
    try {
      setLoading(true);
      setError(null);
      setErrors((prevState) => ({
        ...prevState,
        firstName: "",
        lastName: "",
        email: "",
      }));

      const res = await upateUserPersonalInformation({
        lastName,
        firstName,
        showVisibility,
      });

      const { message } = res.data;
      setLoading(false);

      openNotificationWithIcon(
        "success",
        "Update Personal Information",
        message
      );

      dispatch(
        updateUser({
          user: {
            ...user,
            lastName,
            firstName,
            showVisibility,
          },
        })
      );

      setEditMode(false);
    } catch (error: any) {
      setLoading(false);
      const otherErrors: any[] = [];
      if (error?.response) {
        if (error?.response?.data?.errors) {
          const resError = error?.response?.data?.errors;

          Object.entries(resError).forEach(([key, value]) => {
            if (Object.keys(errors).includes(key)) {
              setErrors((prevState) => ({
                ...prevState,
                [key]: value,
              }));
            } else {
              otherErrors.push(value);
            }
          });

          if (otherErrors.length > 0) {
            const errorList = otherErrors.map((element: any, index) => {
              return <li key={`error-list-${index}`}>{element}</li>;
            });
            setError(errorList);
          }
        } else {
          setError(error?.response?.data?.message || "Something went wrong");
        }
      } else {
        setError("Something went wrong");
      }
    }
  };

  useEffect(() => {
    form.setFieldsValue({
      email: user?.email,
      firstName: user?.firstName,
      lastName: user?.lastName,
    });
    setShowVisibility(
      user?.showVisibility === undefined ? false : user?.showVisibility
    );
  }, [user, form]);

  return (
    <div>
      <p className="mb-[1.8rem] text-[20px] font-semibold leading-[28px] text-appcolorblack">
        Account Info
      </p>

      <div className="rounded-[12px] border border-appcolorgreyfaintfive bg-appcolorwhite px-5 py-[1.3rem]">
        <div className="mb-[1.6rem] flex items-center justify-between">
          <p className="text-[18px] font-semibold leading-[110%] text-appcolorblack">
            Personal Information
          </p>

          <div
            className="flex items-center cursor-pointer"
            onClick={() => {
              if (!loading) {
                setEditMode(!editMode);
              }
            }}
          >
            <p className="mr-1 text-sm font-semibold text-appcolorpurple">
              Edit
            </p>
            <img
              src="/img/vectors/edit.svg"
              alt="edit"
              className="cursor-pointer"
            />
          </div>
        </div>

        <div>
          {error !== null ? (
            <div className="mb-4">
              <Alert message={error} type="error" />
            </div>
          ) : null}

          <Form layout="vertical" form={form} onFinish={onFinish}>
            <Row gutter={16}>
              <Col lg={12} md={24} xs={24}>
                {!editMode ? (
                  <div>
                    <p className="mb-3 text-sm font-medium text-appcolorblack opacity-[0.5]">
                      Name
                    </p>
                    <p className="text-base capitalize text-appcolorblack">
                      {user?.firstName} {user?.lastName}
                    </p>
                  </div>
                ) : (
                  <Row gutter={16}>
                    <Col lg={12} md={24} xs={24}>
                      <Form.Item
                        label="First Name"
                        name="firstName"
                        rules={[
                          { required: true, message: "Input is required" },
                        ]}
                        validateStatus={
                          errors?.firstName.length > 0 ? "error" : undefined
                        }
                        help={
                          errors?.firstName.length > 0
                            ? errors?.firstName
                            : undefined
                        }
                      >
                        <Input
                          placeholder="Enter your first name"
                          onChange={() => {
                            setErrors((prevState) => ({
                              ...prevState,
                              firstName: "",
                            }));
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col lg={12} md={24} xs={24}>
                      <Form.Item
                        label="Last Name"
                        name="lastName"
                        rules={[
                          { required: true, message: "Input is required" },
                        ]}
                        validateStatus={
                          errors?.lastName.length > 0 ? "error" : undefined
                        }
                        help={
                          errors?.lastName.length > 0
                            ? errors?.lastName
                            : undefined
                        }
                      >
                        <Input
                          onChange={() => {
                            setErrors((prevState) => ({
                              ...prevState,
                              lastName: "",
                            }));
                          }}
                          placeholder="Enter your last name"
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                )}
              </Col>
              <Col lg={12} md={24} xs={24}>
                {!editMode ? (
                  <div>
                    <p className="mb-3 text-sm font-medium text-appcolorblack opacity-[0.5]">
                      Email Address
                    </p>
                    <p className="text-base text-appcolorblack">
                      {user?.email}
                    </p>
                  </div>
                ) : (
                  <Form.Item
                    label="Email"
                    name="email"
                    rules={[
                      { required: true, message: "Input is required" },
                      { type: "email", message: "Email is invalid" },
                    ]}
                    validateStatus={
                      errors?.email.length > 0 ? "error" : undefined
                    }
                    help={errors?.email.length > 0 ? errors?.email : undefined}
                  >
                    <Input
                      disabled
                      onChange={() => {
                        setErrors((prevState) => ({
                          ...prevState,
                          email: "",
                        }));
                      }}
                      placeholder="Enter your email"
                    />
                  </Form.Item>
                )}
              </Col>
            </Row>
          </Form>

          <div className={`flex ${editMode ? "" : "mt-10"}`}>
            <div>
              <Switch
                disabled={!editMode}
                checked={showVisibility}
                onChange={(value) => {
                  setShowVisibility(value);
                }}
              />
            </div>
            <div className="pl-[0.6rem]">
              <p className="mb-2 text-sm text-appcolorpurplefive">
                Show Visibility
              </p>
              <p className="text-sm text-appcolorblack">
                When this is on, you can be found by other users on the
                Codefunhouse community
              </p>
            </div>
          </div>

          {editMode ? (
            <div className="mt-[2.5rem] flex justify-end">
              <Button
                onClick={() => {
                  setEditMode(false);
                }}
                style={{
                  color: "#200E32 !important",
                }}
                disabled={loading}
                className="custom-white-btn black-text smaller-padding mr-[0.9rem]"
              >
                Cancel
              </Button>

              <Button
                disabled={loading}
                className="custom-primary-two-btn smaller-padding"
                loading={loading}
                onClick={() => {
                  form.submit();
                }}
              >
                Update
              </Button>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default Teacheraccountinfo;
